export const SWAP_TRANSITION = { duration: 0.22, ease: "easeInOut" } as const;
